import React from 'react'
import { CommonLogin } from '@verifier-user/verifier-cdr'
import { useApplicationContext } from '../../contexts/appContext'

export const AngleIntro = ({
  vendorSettings: vendorSettings,
  currentErrorRef: currentErrorRef,
  setProcessing: setProcessing,
  setError: setError,
  setErrorShown: setErrorShown
}) => {
  const { vendorData, customerLogin, setCustomerLogin, getLoginUrl } = useApplicationContext()

  const smsLoginEnabled = process.env.SMS_LOGIN_ENABLED === 'true'
  const loginUrl = getLoginUrl()

  return (
    <CommonLogin
      currentErrorRef={currentErrorRef}
      setProcessing={setProcessing}
      setError={setError}
      setErrorShown={setErrorShown}
      customerLogin={customerLogin}
      setCustomerLogin={setCustomerLogin}
      loginUrl={loginUrl}
      smsLoginEnabled={smsLoginEnabled}
    >
      <div className='max-w-screen-md'>
        <p className='text-md' data-testid='welcome-brand-text'>
          Welcome to the {vendorSettings?.viewSettings?.financierBrandName || vendorSettings?.customer || 'YourLender'}{' '}
          income verification process. Please follow the simple steps below.
        </p>
        <p className='text-md'>
          For further information, please contact your Business Manager at {vendorData?.dealer || 'DealerShip'}.
        </p>
      </div>

      <h1 className='text-4xl mb-2 leading-normal'>Verify your income</h1>
      <p>
        <span className='text-md'>
          We've partnered with Verifier to help you verify your income by using your bank data. Verifier uses the
          Consumer Data Right (CDR) and asks for your consent at every step along the way. Verifier is a CDR accredited
          data recipient.
        </span>
      </p>
    </CommonLogin>
  )
}
